import { render, staticRenderFns } from "./ProjectInvite.vue?vue&type=template&id=7a13cfd1"
import script from "./ProjectInvite.vue?vue&type=script&lang=js"
export * from "./ProjectInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports